import React from 'react';
import { Gift } from 'lucide-react';
import { Col, Row } from '../../../lib/utils';
import { Body2Bold, CaptionRegular } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import { PaymentOrderView } from '../types';

interface OrderSummaryCardProps {
    order: PaymentOrderView;
}

const OrderSummaryCard: React.FC<OrderSummaryCardProps> = ({ order }) => {
    const { product } = order;
    const quantity = order.quantity ?? 1;

    return (
        <Row
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '20px',
                gap: 14,
                alignItems: 'center',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <div
                style={{
                    width: 52,
                    height: 52,
                    borderRadius: 14,
                    backgroundColor: '#EFF6FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <Gift size={26} color={colors.primary} />
            </div>
            <Col style={{ flex: 1, gap: 3 }}>
                <CaptionRegular style={{ color: colors.LAVEL_1 }}>{product.brand}</CaptionRegular>
                <Body2Bold style={{ color: colors.LAVEL_4 }}>
                    {/* 수량 지정 발송 — "상품명 × N" (기능기획_선물수량지정 §7) */}
                    {quantity > 1 ? `${product.name} × ${quantity}` : product.name}
                </Body2Bold>
                <CaptionRegular style={{ color: colors.LAVEL_2 }}>
                    유효기간 : 발급일로부터 {product.validDays}일
                </CaptionRegular>
            </Col>
        </Row>
    );
};

export default OrderSummaryCard;
